'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _debounce2 = require('lodash/debounce');

var _debounce3 = _interopRequireDefault(_debounce2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ClearableInput.scss');

var ClearableInput = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(ClearableInput, _PureComponent);

  function ClearableInput() {
    var _ref;

    (0, _classCallCheck3.default)(this, ClearableInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClearableInput.__proto__ || (0, _getPrototypeOf2.default)(ClearableInput)).call.apply(_ref, [this].concat(args)));

    _this.delayedOnChange = (0, _debounce3.default)(_this.props.onChange, 300);

    _this.state = { kw: _this.props.kw };
    return _this;
  }

  (0, _createClass3.default)(ClearableInput, [{
    key: 'onChange',
    value: function onChange(e) {
      this.setKw(e.target.value);
    }
  }, {
    key: 'setKw',
    value: function setKw(kw) {
      var _props = this.props,
          delay = _props.delay,
          onChange = _props.onChange;

      this.setState({ kw: kw });
      if (!kw) {
        this.delayedOnChange.cancel();
        return setTimeout(function () {
          return onChange(kw);
        }, 0);
      }
      return delay ? this.delayedOnChange(kw) : onChange(kw);
    }
  }, {
    key: 'clearFilter',
    value: function clearFilter() {
      this.setKw('');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          inputProps = _props2.inputProps,
          inputClassName = _props2.inputClassName,
          title = _props2.title,
          showLabel = _props2.showLabel;
      var kw = this.state.kw;

      var type = inputProps.type || 'text';
      var isShowLabel = showLabel && title;

      return _react2.default.createElement(
        'div',
        { className: styles.container },
        isShowLabel && _react2.default.createElement(
          'span',
          { className: styles.title },
          title,
          ':'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.inputContainer },
          _react2.default.createElement('input', (0, _extends3.default)({}, inputProps, {
            type: type,
            value: kw,
            onChange: this.onChange,
            placeholder: title,
            className: (0, _bind2.default)(inputClassName)
          })),
          _react2.default.createElement('i', { className: 'icon-close', onClick: this.clearFilter })
        )
      );
    }
  }]);
  return ClearableInput;
}(_react.PureComponent), _class2.propTypes = {
  delay: _propTypes2.default.number,
  inputClassName: _propTypes2.default.string,
  inputProps: _propTypes2.default.object,
  kw: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  showLabel: _propTypes2.default.bool,
  title: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string])
}, _class2.defaultProps = {
  delay: 0,
  inputProps: {},
  kw: '',
  onChange: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onChange'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'clearFilter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'clearFilter'), _class.prototype)), _class);
exports.default = ClearableInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ClearableInput/ClearableInput.js
// module id = 819
// module chunks = 1